import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-simcards-main",
    templateUrl: "./simcards.main.component.html",
    standalone: false
})
export class SimCardsMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
